import { Action } from '@ngrx/store';

export enum GhostLoginActionTypes {
  RESET_GMB_CHANNEL_ATTEMPT = '[Reset GMB Channel Attempt] Reset GMB Channel Attempt',
  RESET_GMB_CHANNEL_SUCCESS = '[Reset GMB Channel Success] Reset GMB Channel Success',
  RESET_GMB_CHANNEL_FAILURE = '[Reset GMB Channel Failure] Reset GMB Channel Failure',

  ACTIVATE_GMB_CHANNEL_ATTEMPT = '[Activate GMB Channel Attempt] Activate GMB Channel Attempt',
  ACTIVATE_GMB_CHANNEL_SUCCESS = '[Activate GMB Channel Success] Activate GMB Channel Success',
  ACTIVATE_GMB_CHANNEL_FAILURE = '[Activate GMB Channel Failure] Activate GMB Channel Failure',
}

export class ResetGMBChannelAttempt implements Action {
  readonly type = GhostLoginActionTypes.RESET_GMB_CHANNEL_ATTEMPT;
}

export class ResetGMBChannelSuccess implements Action {
  readonly type = GhostLoginActionTypes.RESET_GMB_CHANNEL_SUCCESS;
}

export class ResetGMBChannelFailure implements Action {
  readonly type = GhostLoginActionTypes.RESET_GMB_CHANNEL_FAILURE;
}

export class ActivateGMBChannelAttempt implements Action {
  readonly type = GhostLoginActionTypes.ACTIVATE_GMB_CHANNEL_ATTEMPT;
}

export class ActivateGMBChannelSuccess implements Action {
  readonly type = GhostLoginActionTypes.ACTIVATE_GMB_CHANNEL_SUCCESS;
}

export class ActivateGMBChannelFailure implements Action {
  readonly type = GhostLoginActionTypes.ACTIVATE_GMB_CHANNEL_FAILURE;
}

export type GhostLoginActions =
  | ResetGMBChannelAttempt
  | ResetGMBChannelFailure
  | ResetGMBChannelSuccess
  | ActivateGMBChannelAttempt
  | ActivateGMBChannelSuccess
  | ActivateGMBChannelFailure;
